import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Schedule from './pages/Schedule';
import Technicians from './pages/Technicians';
import Products from './pages/Products';
import ServiceCatalog from './pages/ServiceCatalog';
import Proposals from './pages/Proposals';
import SignProposal from './pages/SignProposal';
import Settings from './pages/Settings';
import Invoicing from './pages/Invoicing';
import TimingPerformance from './pages/TimingPerformance';
import Reports from './pages/Reports';
import OperationalReports from './pages/OperationalReports';
import SystemMaintenance from './pages/SystemMaintenance';
import ReportQueue from './pages/ReportQueue';
import AuditTrail from './pages/AuditTrail';
import SecurityTracking from './pages/SecurityTracking';
import PublicComplaintLog from './pages/PublicComplaintLog';
import LiveTracking from './pages/LiveTracking';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      
      {/* Clients - all drill-down handled by ClientsSearch internal state */}
      <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
      <Route path="/clients/:clientId" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
      <Route path="/clients/:clientId/facility/:facilityId" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
      
      <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
      <Route path="/technicians" element={<ProtectedRoute><Technicians /></ProtectedRoute>} />
      <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
      <Route path="/service-catalog" element={<ProtectedRoute><ServiceCatalog /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/proposals" element={<ProtectedRoute><Proposals /></ProtectedRoute>} />
      <Route path="/invoicing" element={<ProtectedRoute><Invoicing /></ProtectedRoute>} />
      <Route path="/sign/:token" element={<SignProposal />} />
      <Route path="/timing" element={<ProtectedRoute><TimingPerformance /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/operational-reports" element={<ProtectedRoute><OperationalReports /></ProtectedRoute>} />
      <Route path="/system-maintenance" element={<ProtectedRoute><SystemMaintenance /></ProtectedRoute>} />
      <Route path="/report-queue" element={<ProtectedRoute><ReportQueue /></ProtectedRoute>} />
      <Route path="/audit-trail" element={<ProtectedRoute><AuditTrail /></ProtectedRoute>} />
      <Route path="/security" element={<ProtectedRoute><SecurityTracking /></ProtectedRoute>} />
      <Route path="/log/:token" element={<PublicComplaintLog />} />
        <Route path="/live-tracking" element={<ProtectedRoute><LiveTracking /></ProtectedRoute>} />
      
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function AppWithModals() {
  const { isAuthenticated } = useAuth();
  return (
    <>
      <AppRoutes />
    </>
  );
}
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppWithModals />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
